import { connect } from 'react-redux';
import { Graphics as Component } from './Graphics';
import {
   toggleModalPs,
   togglePowerPs,
   setTimerPs,
   setVoltagePs,
   setCurrentPs,
   onStartPowerSupplyPs,
   onStopPowerSupplyPs,
   animationPlaybackCompletePs,
   onDropWirePs,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
   return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].type,
      anodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].anodeConnected,
      cathodeConnected: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].cathodeConnected,

      modalOpen: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].modalOpen,
      power: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].power,
      pluggedIn: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].pluggedIn,

      settings: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].settings,
      running: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].running,
      completed: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].completed,
      cables: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].cables,

      controlsVisible: state.notebook.protocolSection.scene.apparatus.powerSupply[ownProps.id -1].controlsVisible,
      interactionProps: {
         agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel,
         gelBoxes: state.notebook.protocolSection.scene.apparatus.gelBoxes,
         powerSupplyLead: state.notebook.protocolSection.scene.apparatus.powerSupplyLead,
       }
   }
}

function mapDispatchToProps(dispatch) {
   return {
      toggleModalPs: (data) => {
         dispatch(toggleModalPs(data))
      },
      togglePowerPs: (data) => {
         dispatch(togglePowerPs(data))
      },
      setTimerPs: (data) => {
         dispatch(setTimerPs(data))
      },
      setVoltagePs: (data) => {
         dispatch(setVoltagePs(data))
      },
      setCurrentPs: (data) => {
         dispatch(setCurrentPs(data))
      },
      onStartPowerSupplyPs: (data) => {
         dispatch(onStartPowerSupplyPs(data))
      },
      onStopPowerSupplyPs: (data) => {
         dispatch(onStopPowerSupplyPs(data))
      },
      animationPlaybackCompletePs: (data) => {
         dispatch(animationPlaybackCompletePs(data))
      },
      onDropWirePs: (data) => {
         dispatch(onDropWirePs(data))
      },
   };
}

export const Graphics = connect(
   mapStateToProps,
   mapDispatchToProps
)(Component);
